/* eslint-disable dot-notation */
export const removeStorageCampaigns = () => {
  const CREDITAS_AFFILIATES_STATE = 'creditas-affiliates-state'
  const stateStorage = JSON.parse(
    localStorage.getItem(CREDITAS_AFFILIATES_STATE),
  )
  const settings = stateStorage ? stateStorage['settings'] : {}
  for (const key in settings) {
    if (settings.hasOwnProperty(key)) {
      if (
        key === 'showCampaign' ||
        key === 'showModalCampaign' ||
        key === 'showHeroCampaign'
      ) {
        delete settings[key]
      }
    }
  }
  localStorage.setItem(CREDITAS_AFFILIATES_STATE, JSON.stringify(stateStorage))
}
